/* eslint-disable react/require-default-props */
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

type MemberResignMemberConfirmDialogProps = {
  title: string;
  modaltext?: string;
  open: boolean;
  onClose: () => void;
  onSave: () => void;
};

export const MemberResignMemberConfirmDialog = (props: MemberResignMemberConfirmDialogProps) => {
  const { t } = useTranslation();
  const { title, modaltext, onClose, onSave, open } = props;

  const dialogId = `confirmation-dialog-title-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`;

  return (
    <Dialog onBackdropClick={() => false} disableEscapeKeyDown maxWidth='xs' aria-labelledby={dialogId} open={open}>
      <DialogTitle id={dialogId}>{title}</DialogTitle>
      {modaltext && <DialogContent>{modaltext}</DialogContent>}
      <DialogActions>
        <Button autoFocus onClick={onClose} color='primary'>
          {t('common:button.no')}
        </Button>
        <Button onClick={onSave} color='primary' variant='contained'>
          {t('common:button.yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
